module.exports = __webpack_public_path__ + "img/pdf-file.b52e7395.svg";